import { Controller } from "@hotwired/stimulus";
import $ from "jquery";

export default class extends Controller {
  static values = { param: String };

  connect() {
    if (!this.shouldOpenModal() || this.isPreview()) return;

    this.openModalWithRetry();
  }

  shouldOpenModal() {
    if (!this.element?.id) return false;

    const paramName = this.paramValue || "modal_id";
    const url = new URL(window.location.href);
    const value = url.searchParams.get(paramName);
    if (!value) return false;

    return value === this.element.id || this.element.id.endsWith(`-${value}`);
  }

  isPreview() {
    return (
      document.documentElement.hasAttribute("data-turbolinks-preview") ||
      document.documentElement.hasAttribute("data-turbo-preview")
    );
  }

  openModalWithRetry(attempt = 0) {
    if (typeof $(this.element).modal !== "function") {
      if (attempt < 10) {
        setTimeout(() => this.openModalWithRetry(attempt + 1), 75);
      }
      return;
    }

    $(this.element)
      .off("shown.bs.modal.query-modal")
      .one("shown.bs.modal.query-modal", () => this.removeParam());

    $(this.element).modal("show");
  }

  removeParam() {
    const paramName = this.paramValue || "modal_id";
    const url = new URL(window.location.href);
    if (!url.searchParams.has(paramName)) return;

    url.searchParams.delete(paramName);
    window.history.replaceState(null, "", url.toString());
  }
}
